import React from 'react';

export const PortofolioDetailPage = React.lazy(() => import('@features/portofolio/pages/portofolio-detail/portofolio-detail'));
